<template>
	<div id="om-app">
		<core-alert-bar />
		<transition name="fade" mode="out-in" @after-enter="triggerScroll" @after-leave="triggerScroll">
			<router-view @hook:mounted="routerComponentMounted" />
		</transition>
		<common-quick-links />
		<modals-pro-feature v-bind="upsellProps" />
	</div>
</template>
<script lang="js">
import isObject from 'lodash/isObject'
import { mapActions } from 'vuex'

export default {
	data () {
		return {
			upsellProps : {
				utmMedium : 'CampaignsTable',
				features  : [],
			},
			timeout : null,
		}
	},
	mounted () {
		this.$bus.$on('toggleProModal', this.toggleProModal)
		this.$bus.$on('fetchedWpResources', this.maybeUpdateMe)
		if (this.$store.getters.shouldFetchUser) {
			this.fetchMe()
		}
	},
	beforeDestroy () {
		this.$bus.$off('toggleProModal', this.toggleProModal)
		this.$bus.$off('fetchedWpResources', this.maybeUpdateMe)
	},
	methods : {
		...mapActions([ 'fetchMe', 'updateMe' ]),
		triggerScroll () {
			this.$root.$emit('triggerScroll')
		},
		toggleProModal (utmMedium = 'CampaignsTable', features = []) {
			this.upsellProps = isObject(utmMedium)
				? utmMedium
				: { utmMedium, features }

			this.$modal.show('pro-feature')
		},
		maybeUpdateMe () {
			if (this.timeout) {
				clearTimeout(this.timeout)
			}
			this.timeout = setTimeout(() => this.updateMe(), 1000)
		},
		routerComponentMounted () {
			this.$bus.$emit('routerComponentMounted')
		},
	},
};
</script>
<style lang="scss">
@import 'assets/scss/app';
.omapi-screen {
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.2s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
}
</style>
